/**
 * @format
 */
import {connect} from 'react-redux';
import {ClientsPageView} from '../components';

const ClientsPage = connect()(ClientsPageView);

export {ClientsPage};
